import React from 'react';
import { Link } from 'react-router-dom';
import { ADD_BETSLIP } from '../../../routes/paths';
import contentStackImageUrls from '../../../../resources/contentStackImageUrls.json';

const { plusCard } = contentStackImageUrls;

const NoBetsAnonymous = () => (
  <div className="no-bets">
    <section className="no-bets__section">
      <h2 className="no-bets__heading">No recent activity</h2>
    </section>
    <section className="no-bets__section">
      <img
        src={plusCard}
        onError={(e) => { e.target.src = '../../../../assets/images/landing/plus-card.png'; }}
        alt="Plus card"
        className="no-bets__card"
      />
      <p className="no-bets__paragraph">
        <b>Got a Plus card, yet?</b>
      </p>
      <p className="no-bets__paragraph">
        Pick one up the next time you visit.<br />
        You can use it with our in-store
        betting points, so all of your future
        bets can be automatically added here.
      </p>
    </section>
    <section className="no-bets__section">
      <p className="no-bets__paragraph">
        <span className="no-bets__divider no-bets__divider--inline" />
        <b>OR</b>
        <span className="no-bets__divider no-bets__divider--inline" />
      </p>
    </section>
    <section className="no-bets__section">
      <p className="no-bets__paragraph">
        <Link to={ADD_BETSLIP} className="no-bets__link">
          Add your bets manually
        </Link>
      </p>
    </section>
  </div>
);

export default NoBetsAnonymous;
